import * as React from 'react';
import { compose } from 'redux';

import Dropdown from 'af-components/Controls/Dropdown';

import styles from './styles.module.scss';

export interface LocationFilterOption {
	id: number;
	label: string;
}

interface OwnProps {
	onChange: (option: Nullable<LocationFilterOption>) => void;
	options: LocationFilterOption[];
}

type Props = OwnProps;

const LocationFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		options,
	} = props;

	const renderOption = React.useCallback((option: LocationFilterOption) => {
		return (
			<>
				{option.label}
			</>
		);
	}, []);

	const filterBy = React.useCallback((option: LocationFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<LocationFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				labelKey={'label'}
				onValueChange={onChange}
				options={options}
				placeholder="Select Location"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo
);

export default enhance(LocationFilter);
